import { colors, Icons } from 'bold-ui'
import { ColorScale } from 'bold-ui/lib/styles/colors'

import {
  ConsultaSeguimentoFieldModel,
  ConsultaSeguimentoViewModel,
} from './consulta-seguimento/model-consultaSeguimento'
import { MChatFieldModel, MChatViewModel } from './mchat/model-mchat'

export interface MChatRfFieldModel {
  mchat: MChatFieldModel
  consultaSeguimento: ConsultaSeguimentoFieldModel
}

export interface MChatRfViewModel {
  mchat: MChatViewModel
  consultaSeguimento: ConsultaSeguimentoViewModel
}

export enum MChatRfAccordionSectionEnum {
  MCHAT = 'MCHAT',
  CONSULTA_SEGUIMENTO = 'CONSULTA_SEGUIMENTO',
}

export type MChatRfResultadoStatus = 'success' | 'warning' | 'error'

export const MCHAT_RF_ACCORDION_SECTIONS = (
  M_CHAT_RF_ENABLED: boolean
): Record<MChatRfAccordionSectionEnum, { title: string; description: string }> => ({
  MCHAT: {
    title: 'M-CHAT-R™',
    description: 'Aplicação a partir dos 16 meses até 30 meses.',
  },
  CONSULTA_SEGUIMENTO: {
    title: 'Entrevista de seguimento',
    description: `A entrevista de seguimento é recomendada para resultados dentro do Risco Médio no M-CHAT-R.${
      !M_CHAT_RF_ENABLED ? ' Acesse o documento original para aplicar a avaliação.' : ''
    }`,
  },
})

export const MCHAT_RF_RESULTADO_BY_STATUS: Record<MChatRfResultadoStatus, { icon: Icons; colorScale: ColorScale }> = {
  success: {
    colorScale: colors.green,
    icon: 'infoCircleOutline',
  },
  warning: {
    colorScale: colors.orange,
    icon: 'exclamationTriangleOutline',
  },
  error: {
    colorScale: colors.red,
    icon: 'exclamationTriangleOutline',
  },
}
